export default {
  computed: {
    userCompanies () {
      return this.$oauth2?.me?.companies || [];
    },
    userCompaniesRoles () {
      const userCompaniesHash = {};

      this.userCompanies.forEach(uc => {
        userCompaniesHash[uc.id] = uc.role;
      });

      return userCompaniesHash;
    },
  },
  methods: {
    userCompanyRole (companyId) {
      if (!companyId) {
        return null;
      }

      return this.userCompaniesRoles[companyId] || null;
    },
  },
};
